import { Container, Row, Col } from "react-bootstrap";

import "animate.css";
import "./css/ReadyMadeSoftware.css";

import TrackVisibility from "react-on-screen";

export const ReadyMadeSoftware = () => {
  const products = [
    {
      name: "Shopnio",
      tag: "Marketplace-in-a-Box Solution",
      positioning:
        "Launch your own Daraz-style online marketplace with complete ecosystem support.",
      type: "Ready-Made + Customizable",
      features: [
        "User website",
        "Admin dashboard",
        "Seller panel",
        "Customer mobile app",
        "Seller app",
        "Delivery app",
        "Vendor commission system",
        "Product approval system",
        "Coupon and campaign management",
        "Advanced reporting",
        "Role-based access control",
        "Secure payment integration",
        "Order and inventory management",
      ],
      idealFor: [
        "Marketplace entrepreneurs",
        "Local city ecommerce platforms",
        "Regional ecommerce investors",
      ],
      accent: "green",
      demoLink: "https://myzoo.braintodo.com/",
    },
    {
      name: "QuickCart",
      tag: "Complete Online Store Solution",
      positioning:
        "Everything you need to run your own professional ecommerce store.",
      type: "Ready-Made",
      features: [
        "Responsive website",
        "Admin panel",
        "Order management",
        "Product and category management",
        "Inventory tracking",
        "Coupon system",
        "Customer management",
        "Payment gateway integration",
        "Sales analytics dashboard",
      ],
      idealFor: [
        "Retail shop owners",
        "Brand owners",
        "Boutique and fashion stores",
        "Electronics stores",
      ],
      accent: "blue",
      demoLink: "https://jashorebro.com/",
    },
    {
      name: "DropX",
      tag: "Smart Dropshipping Automation",
      positioning:
        "Run a dropshipping business without managing physical inventory.",
      type: "Ready-Made + Integration-Based",
      features: [
        "Product import system",
        "Supplier management",
        "Auto order processing",
        "Profit margin control",
        "Order tracking",
        "Customer notification system",
        "Multi-supplier support",
        "Inventory sync logic",
      ],
      idealFor: [
        "Beginner entrepreneurs",
        "Low-investment starters",
        "Social media sellers",
      ],
      accent: "purple",
      demoLink: "https://dropship.biswasandbrothers.com/",
    },
    {
      name: "BrainToDo HRM",
      tag: "Workforce Management Simplified",
      positioning:
        "Digitize HR operations with a centralized management system.",
      type: "Customizable",
      features: [
        "Employee management",
        "Attendance tracking",
        "Payroll automation",
        "Leave management",
        "Performance monitoring",
        "Department structure setup",
        "Role and permission control",
        "Reporting and analytics",
      ],
      idealFor: [
        "SMEs",
        "Corporate offices",
        "Growing companies",
      ],
      accent: "yellow",
      demoLink: "https://braintodo.com/",
    },
    {
      name: "BrainToDo CRM",
      tag: "Sales and Client Pipeline Control",
      positioning:
        "Manage leads, clients, and sales processes in one powerful dashboard.",
      type: "Customizable",
      features: [
        "Lead management",
        "Sales pipeline tracking",
        "Task assignment",
        "Follow-up reminder system",
        "Client database",
        "Revenue tracking",
        "Activity logs",
        "Team collaboration tools",
      ],
      idealFor: [
        "Agencies",
        "Sales teams",
        "Service-based companies",
        "Real estate firms",
      ],
      accent: "orange",
      demoLink: "https://braintodo.com/",
    },
    {
      name: "Custom Web and Mobile App Development",
      tag: "Built for Your Unique Business Model",
      positioning:
        "From idea to scalable digital product, fully engineered and optimized.",
      type: "Services",
      features: [
        "Web application development",
        "Flutter mobile app development",
        "Backend architecture design",
        "API development and integration",
        "Database structuring",
        "SaaS development",
        "Ongoing maintenance and scaling",
      ],
      idealFor: [
        "Founders with new ideas",
        "Growing businesses",
        "Product teams",
      ],
      accent: "diamond",
      demoLink: "",
    },
  ];

  return (
    <section className="ready-made" id="ready-made">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <header className="ready-made-header">
                    <p className="ready-made-eyebrow">Ready-made software</p>
                    <h2 className="ready-made-title">Launch Software with Fahim</h2>
                    <p className="ready-made-subtitle">
                     These Software products are fully developed by me and now I offer them for your business needs.
                     You can get these products as they are or with customizations.
                    </p>
                  </header>

                  <Row className="g-4">
                    {products.map((product) => (
                      <Col key={product.name} xs={12} md={6} xl={4}>
                        <article className={`ready-made-card accent-${product.accent}`}>
                          <div className="card-top">
                            <div>
                              <h3 className="card-title">{product.name}</h3>
                              <p className="card-tag">{product.tag}</p>
                            </div>
                            <span className="card-type">{product.type}</span>
                          </div>

                          <p className="card-positioning">{product.positioning}</p>

                          <div className="card-section">
                            <p className="card-label">Key features</p>
                            <ul className="card-list">
                              {product.features.map((feature) => (
                                <li key={feature}>{feature}</li>
                              ))}
                            </ul>
                          </div>

                          <div className="card-section">
                            <p className="card-label">Ideal for</p>
                            <div className="card-tags">
                              {product.idealFor.map((item) => (
                                <span className="tag-chip" key={item}>{item}</span>
                              ))}
                            </div>
                          </div>

                          <div className="card-section">
                            <p className="card-label">Demo</p>
                            <a
                              className="demo-link"
                              href={product.demoLink}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {product.demoLink}
                            </a>
                          </div>

                          <div className="card-cta-row">
                            <a
                              href="https://wa.me/8801782084390"
                              className="card-cta"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              WhatsApp
                            </a>
                            <a href="mailto:ridoyfahim92@gmail.com" className="card-cta ghost">
                              Email
                            </a>
                          </div>
                        </article>
                      </Col>
                    ))}
                  </Row>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
